import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { PwLocaleService } from '@pw-locale';

@Component({
  selector: 'pw-user-picture-preloader',
  templateUrl: './user-picture-preloader.component.html',
  styleUrls: ['./user-picture-preloader.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserPicturePreloaderComponent implements OnInit {
  @Input() public userPictureUrl: string;
  @Input() public showLoader = true;
  public hasLoadError = false;
  public successfullyLoaded = false;
  public alreadyBeenInViewPort = false;

  constructor(public locale: PwLocaleService) {}

  ngOnInit(): void {}
}
